import { HiChevronLeft } from 'react-icons/hi'
import classNames from 'classnames'

interface PrevProps {
    currentPage: number
    pagerClass: {
        default: string
        inactive: string
        active: string
        disabled: string
    }
    onPrev: () => void
}

const Prev = (props: PrevProps) => {
    const { currentPage, pagerClass, onPrev } = props

    const disabled = currentPage <= 1

    const onPrevClick = () => {
        if (disabled) {
            return
        }
        onPrev()
    }

    const pagerPrevClass = classNames(
        pagerClass.default,
        disabled && pagerClass.disabled
    )

    return (
        <button className={pagerPrevClass} onClick={onPrevClick} disabled={disabled}>
            <HiChevronLeft />
        </button>
    )
}

export default Prev 